import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, setToken, getToken } from '../api/client';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    if (!getToken()) { setLoading(false); return; }
    try {
      const { user } = await api.get('/auth/me');
      setUser(user);
    } catch {
      setToken(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const loginWithCredential = async (credential) => {
    const { token, user } = await api.post('/auth/google', { credential });
    setToken(token);
    setUser(user);
    return user;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    window.location.href = '/';
  };

  const refreshUser = async () => { await loadMe(); };

  return (
    <AuthContext.Provider value={{ user, loading, loginWithCredential, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}
